import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import './styles.scss';

const DEFAULT_Z_INDEX = 1500;

const POSITIONS = {
  center: 'justify-center',
  start: 'justify-start',
  end: 'justify-end',
};

function ModalWrapper({
  children,
  darkBackground = true,
  className = '',
  zIndex = null,
  position = 'center',
  onClose = null,
}) {
  return ReactDOM.createPortal(
    <div
      className={`modal-wrapper ${POSITIONS[position] || POSITIONS.center} ${className}`}
      style={{ '--z-index': zIndex || DEFAULT_Z_INDEX }}
    >
      {children}
      <div onClick={onClose} className={`modal-wrapper__background ${darkBackground ? 'modal-wrapper__background--dark' : ''}`} />
    </div>,
    document.getElementById('root-modal'),
  );
}

ModalWrapper.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  darkBackground: PropTypes.bool,
  zIndex: PropTypes.number,
  position: PropTypes.oneOf(['center', 'start', 'end']),
  onClose: PropTypes.func,
};

export default ModalWrapper;
